import React, { useEffect, useState } from "react"
import clsx from "clsx"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import ReactTagInput from "@pathofdev/react-tag-input"
import { TagsInput } from "react-tag-input-component"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import Card from "@material-ui/core/Card"
import CardHeader from "@material-ui/core/CardHeader"
import CardMedia from "@material-ui/core/CardMedia"
import CardContent from "@material-ui/core/CardContent"
import CardActions from "@material-ui/core/CardActions"
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"
import { Tooltip } from "@material-ui/core"
import Menu from "@material-ui/core/Menu"
import MenuItem from "@material-ui/core/MenuItem"
import { Divider, Grid, IconButton, Box } from "@material-ui/core"
import Checkbox from "@material-ui/core/Checkbox"
import TextField from "@material-ui/core/TextField"
import { MinimalButton } from "@react-pdf-viewer/core"
import { NextIcon, PreviousIcon } from "@react-pdf-viewer/search"
import FormGroup from "@material-ui/core/FormGroup"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import FormControl from "@material-ui/core/FormControl"
import FormLabel from "@material-ui/core/FormLabel"
import { HighLightUpSVG, HighLightDownSVG } from "../icons"
import { getFileRequestByPage, getPageNumberBasedOnHighlightTextRequest } from "../../actions/documentModalActions"
import { searchHighlightFilter } from "../../actions/highlightActions"
import { ANNO_BG_COLOR } from "../../utils"
import { useHistory } from "react-router-dom"
import _ from "lodash"
import { updateViewerPageNumber } from "../../actions/viewerActions"

const useStyles = makeStyles((theme) => ({
	root: {
		"&:hover": {
			backgroundColor: "transparent",
		},
	},
	icon: {
		borderRadius: 3,
		width: 16,
		height: 16,
		boxShadow: theme.shadows[25],
		backgroundColor: theme.palette.primary.light,
	},
	//For now keeping this colors as static. Once we get the design for UX will add to theme object
	checkedIcon: {
		backgroundColor: theme.palette.primary.dark,
		"&:before": {
			display: "block",
			width: 16,
			height: 16,
			backgroundImage:
				"url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
				" fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
				"1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
			content: '""',
		},
	},
	highlight: {
		flex: 5,
		padding: "16px 23px",
		display: "flex",
		alignItems: "center",
		borderRight: `solid 1px ${theme.palette.grey.D400}`,
	},
	menuItem: {
		borderLeft: `solid 5px ${theme.palette.common.white}`,
		"& .rti--container": {
			width: "100%",
		},
		"& .rti--input": {
			width: "50%",
			boxShadow: "none",
		},
		"& .MuiListItem-root.Mui-focusVisible": {
			backgroundColor: "transparent",
		},
		"&:hover": {
			backgroundColor: "transparent",
		},
		"&:focus": {
			backgroundColor: "transparent",
		},
		"& .MuiListItemIcon-root": {
			color: theme.palette.grey.D300,
		},
		"&.Mui-selected": {
			backgroundColor: "transparent",
			borderLeft: `solid 5px ${theme.palette.primary.dark}`,
			"& .MuiListItemIcon-root": {
				color: theme.palette.primary.dark,
			},
			"& .MuiListItemText-primary": {
				color: theme.palette.text.selected,
				fontWeight: "600",
			},
			"& .MuiButtonBase-root": {
				border: "none",
			},
			"&:hover": {
				backgroundColor: "transparent",
				"& .MuiListItemText-primary": {},
			},
		},
		"& .react-tag-input__tag": {
			background: theme.palette.grey.D1100,
		},
		"& .react-tag-input__tag__remove": {
			backgroundColor: "transparent",
		},
	},
	highlightTitle: {
		width: "100%",
	},
}))

function StyledCheckbox(props) {
	const { retainedFilterJobData } = props
	const params = location?.pathname?.split("/")
	const fileId = params[params.length - 1]
	const classes = useStyles()
	const dispatch = useDispatch()
	const highlightFilter = useSelector((state) => state.highlightFilter.search)
	const { documentDetails } = useSelector((state) => state.documentModal)

	const handleChange = (event) => {
		const filterData = { ...highlightFilter }
		if (event?.target?.name === "annotation" && !highlightFilter["annotation"]) {
			filterData["emails"] = false
			filterData["specificWord"] = false
			filterData["dates"] = false
			filterData["concepts"] = false
			filterData["annotation"] = true
			dispatch(searchHighlightFilter(filterData))
		} else {
			filterData["annotation"] = false
			filterData["saveHighlightState"] = []
			filterData[event?.target?.name] = !highlightFilter[event?.target?.name]
			dispatch(searchHighlightFilter(filterData))
		}
		filterData[event?.target?.name] = !highlightFilter[event?.target?.name]
		if (event?.target?.name === "specificWord" || event?.target?.name === "concepts") {
			if (filterData["specificWord"]) {
			}
			let searchText = filterData["specificWord"] ? highlightFilter?.searchWord : []
			let selectedConcept = filterData["concepts"] ? highlightFilter?.loadedConcept : []
			const payload = {
				categories: retainedFilterJobData?.categories || [],
				text: [...searchText, ...selectedConcept],
				return_count: 20000,
				skip_count: 0,
				suppress_content: false,
				neg_text: "",
				mode: "PAGE",
				treat_like_concept: false,
				selected_database: retainedFilterJobData?.selected_database,
				additional_params: {
					skip_audit: true,
					page_context: params?.[1],
				},
				restrict_file_ids: [fileId],
			}
			dispatch(getPageNumberBasedOnHighlightTextRequest(payload))
		}
		if (event.target?.name == "emails") {
			filterData["email"] = filterData["emails"] ? documentDetails?.metadata?.emails : []
		}
		if (event.target?.name == "dates") {
			filterData["date"] = filterData["dates"] ? documentDetails?.metadata?.dates : []
		}
		dispatch(searchHighlightFilter(filterData))
	}

	return (
		<Checkbox
			className={classes.root}
			disableRipple
			checked={props?.checked}
			color="default"
			name={props?.name}
			size="small"
			onChange={handleChange}
			checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
			icon={<span className={classes.icon} />}
			inputProps={{ "aria-label": "decorative checkbox" }}
			{...props}
		/>
	)
}

const ViewerHighlight = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const history = useHistory()
	const theme = useTheme()
	const [t] = useTranslation("global")
	const [pageNumber, setPageNumber] = useState(1)
	const [anchorEl, setAnchorEl] = useState()
	const [hightlightIndex, setHightlightIndex] = useState(-1)
	const [jumpToNextPage, setJumpToNextPage] = useState(false)
	const [isHighlightDisable, setIsHighlightDisable] = useState(false)
	const [isHighlightStateNext, setIsHighlightStateNext] = useState(null)
	const [disableNextforHighlight, setDisableNextforHighlight] = useState(false)
	const [disablePrevforHighlight, setDisablePrevforHighlight] = useState(false)
	const { retainedFilterJobData, jumpToNextMatch, jumpToPreviousMatch, isNativeformatHeader } = props
	const { currentDocument, f, pageNumberBasedOnHighlightedText, documentDetails } = useSelector((state) => state.documentModal)
	const highlightFilter = useSelector((state) => state.highlightFilter.search)
	const { currentPageNumber } = useSelector((state) => state.viewerData)
	const selectedTag = []
	const params = location?.pathname?.split("/")
	const fileId = params[params.length - 1]

	const open = Boolean(anchorEl)
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}
	const handleClose = () => {
		setAnchorEl(null)
	}

	useEffect(() => {
		setTimeout(() => {
			var elementMark = document.getElementsByClassName("mark_element")
			if (isHighlightStateNext === "next") {
				if (elementMark.length === 1) {
					setJumpToNextPage(true)
				}
				setHightlightIndex(0)
				if (elementMark[0]) {
					elementMark[0].style.border = `solid 3px ${theme.palette.grey.D1200}`
					elementMark[0]?.scrollIntoView(true) - 100
				}
			} else if (isHighlightStateNext === "previous") {
				if (elementMark.length === 1) {
					setJumpToNextPage(true)
				}
				setHightlightIndex(elementMark.length)
				if (elementMark[elementMark.length - 1]) {
					elementMark[elementMark.length - 1].style.border = `solid 3px ${theme.palette.grey.D1200}`
					elementMark[elementMark.length - 1]?.scrollIntoView(true) + 100
				}
			} else {
				setHightlightIndex(-1)
			}
			setIsHighlightDisable(false)
		}, [1000])
	}, [currentDocument])

	const handleChange = (newTags) => {
		const filterData = { ...highlightFilter }
		setHightlightIndex(-1)
		if (newTags !== "") {
			selectedTag.push(newTags)
			filterData["specificWord"] = true
			filterData["searchWord"] = selectedTag.flat()
			dispatch(searchHighlightFilter(filterData))
		}

		if (filterData["specificWord"] || filterData["concepts"]) {
			let searchText = filterData["specificWord"] ? selectedTag.flat() : []
			let selectedConcept = filterData["concepts"] ? highlightFilter?.loadedConcept : []
			const payload = {
				categories: retainedFilterJobData?.categories || [],
				text: [...searchText, ...selectedConcept],
				return_count: 20000,
				skip_count: 0,
				suppress_content: false,
				neg_text: "",
				mode: "PAGE",
				treat_like_concept: false,
				selected_database: retainedFilterJobData?.selected_database,
				additional_params: {
					skip_audit: true,
					page_context: params?.[1],
				},
				restrict_file_ids: [fileId],
			}
			dispatch(getPageNumberBasedOnHighlightTextRequest(payload))
		}
	}

	const getClosestGreaterValue = (array, currentValue) => {
		if (array.length === 0) {
			return null
		}
		const closestIndex = array.findIndex((v) => v > parseInt(currentValue))
		const closestNext = array[closestIndex] || null
		const next = closestIndex === -1 ? null : closestNext
		return next ? next : array[0]
	}

	const getClosestSmallerValue = (list, value) => {
		let i = 0
		while (list[++i] < value);
		return list[--i]
	}

	const loadNextPageHighlight = () => {
		if (currentPageNumber < documentDetails?.metadata?.total_page_number) {
			const id = documentDetails?.file_id
			const page = getClosestGreaterValue(pageNumberBasedOnHighlightedText, currentPageNumber)
			const reviewId = retainedFilterJobData?.additional_params?.review_id
			dispatch(getFileRequestByPage({ id, page, reviewId }))

			dispatch(updateViewerPageNumber(page))
			const viewerContainer = document.getElementById("viewer-container")
			viewerContainer?.scrollIntoView(true)
			setIsHighlightDisable(true)
		}
	}

	const loadPreviousPageHighlight = () => {
		if (currentPageNumber >= 1) {
			const id = documentDetails?.file_id
			let page = getClosestSmallerValue(pageNumberBasedOnHighlightedText, currentPageNumber)
			if (page >= currentPageNumber) {
				page = pageNumberBasedOnHighlightedText[pageNumberBasedOnHighlightedText?.length - 1]
			}
			const reviewId = props.retainedFilterJobData?.additional_params?.review_id
			dispatch(getFileRequestByPage({ id, page, reviewId }))
			dispatch(updateViewerPageNumber(page))
			const viewerContainer = document.getElementById("viewer-container")
			viewerContainer?.scrollIntoView(true)
			setIsHighlightDisable(true)
		}
	}

	const jumpToNextHightlightWord = () => {
		if (jumpToNextPage) {
			loadNextPageHighlight()
			setJumpToNextPage(false)
			return
		}
		try {
			setIsHighlightStateNext("next")
			var elementMark = document.getElementsByClassName("mark_element")
			if (elementMark?.length === 0) {
				loadNextPageHighlight()
				setJumpToNextPage(false)
				return
			}
			for (let item of elementMark) {
				item.style.border = "none"
			}
			var nextH
			if (hightlightIndex === null) {
				nextH = 0
			} else {
				nextH = (hightlightIndex + 1) % elementMark.length || 0
				if (nextH + 1 === elementMark.length) {
					setJumpToNextPage(true)
				}
			}
			setHightlightIndex(nextH)
			elementMark[nextH].style.border = `solid 3px ${theme.palette.grey.D1200}`
			elementMark[nextH]?.scrollIntoView(true) - 100
		} catch (e) {}
	}

	const jumpToPreviousHightlightWord = () => {
		if (jumpToNextPage) {
			loadPreviousPageHighlight()
			setJumpToNextPage(false)
			return
		}
		try {
			setIsHighlightStateNext("previous")
			var elementMark = document.getElementsByClassName("mark_element")
			if (elementMark?.length === 0) {
				loadPreviousPageHighlight()
				setJumpToNextPage(false)
				return
			}
			for (let item of elementMark) {
				item.style.border = "none"
			}
			var nextH
			if (hightlightIndex === null) {
				nextH = 0
			} else {
				if (hightlightIndex === 0) {
					nextH = elementMark.length
					loadPreviousPageHighlight()
					setJumpToNextPage(false)
					return
				}
				if (hightlightIndex === 1) {
					setJumpToNextPage(true)
					nextH = (hightlightIndex - 1) % elementMark.length || 0
					if (nextH <= -1) {
						nextH = -1
					} else if (nextH > elementMark.length) {
						nextH = elementMark.length
					}
				} else {
					nextH = (hightlightIndex - 1) % elementMark.length || 0
					if (nextH <= -1) {
						nextH = -1
					} else if (nextH > elementMark.length) {
						nextH = elementMark.length
					}
				}
			}
			setHightlightIndex(nextH)
			elementMark[nextH].style.border = `solid 3px ${theme.palette.grey.D1200}`
			elementMark[nextH]?.scrollIntoView(true) + 100
		} catch (e) {}
	}

	const jumpToNextHightlightWordWithinFile = () => {
		try {
			var elementMark = document.getElementsByClassName("mark_element")
			for (let item of elementMark) {
				item.style.border = "none"
			}
			var nextH
			if (hightlightIndex === null) {
				nextH = 0
			} else {
				nextH = (hightlightIndex + 1) % elementMark.length || 0
			}
			setHightlightIndex(nextH)
			elementMark[nextH].style.border = `solid 3px ${theme.palette.grey.D1200}`
			elementMark[nextH]?.scrollIntoView(true) - 100
		} catch (e) {}
	}

	const jumpToPreviousHightlightWordWithinFile = () => {
		try {
			var elementMark = document.getElementsByClassName("mark_element")
			for (let item of elementMark) {
				item.style.border = "none"
			}
			var nextH
			if (hightlightIndex === null) {
				nextH = 0
			} else {
				if (hightlightIndex === 0) {
					nextH = elementMark.length
				} else {
					nextH = (hightlightIndex - 1) % elementMark.length || 0
				}
			}
			setHightlightIndex(nextH)
			elementMark[nextH].style.border = `solid 3px ${theme.palette.grey.D1200}`
			elementMark[nextH]?.scrollIntoView(true) + 100
		} catch (e) {}
	}

	const checkforNextJumpPosition = () => {
		if (!isHighlightDisable) {
			if (highlightFilter?.specificWord || highlightFilter?.concepts) {
				if (
					!_.isEmpty(retainedFilterJobData?.text) ||
					!_.isEmpty(retainedFilterJobData?.categories) ||
					!_.isEmpty(highlightFilter?.loadedConcept)
				) {
					jumpToNextHightlightWord()
				} else if (highlightFilter?.specificWord) {
					jumpToNextHightlightWord()
				}
			} else {
				jumpToNextHightlightWordWithinFile()
			}
		}
	}

	const checkforPrevJumpPosition = () => {
		if (!isHighlightDisable) {
			if (highlightFilter?.specificWord || highlightFilter?.concepts) {
				if (
					!_.isEmpty(retainedFilterJobData?.text) ||
					!_.isEmpty(retainedFilterJobData?.categories || !_.isEmpty(highlightFilter?.loadedConcept))
				) {
					jumpToPreviousHightlightWord()
				} else if (highlightFilter?.specificWord) {
					jumpToPreviousHightlightWord()
				}
			} else {
				jumpToPreviousHightlightWordWithinFile()
			}
		}
	}
	return (
		<Box className={classes.highlight}>
			<Box
				id="fade-button"
				aria-controls={open ? "fade-menu" : undefined}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				onClick={handleClick}
				style={{ ...theme.typography.body1, cursor: "pointer" }}
			>
				<Tooltip placement="top" title={t("viewer.highlight")}>
					<Typography noWrap style={{ flex: 3, width: "108px" }}>
						{t("viewer.highlight")}
					</Typography>
				</Tooltip>
			</Box>
			{isNativeformatHeader ? (
				<>
					<MinimalButton onClick={jumpToPreviousMatch}>
						<HighLightUpSVG />
					</MinimalButton>
					<MinimalButton onClick={jumpToNextMatch}>
						<HighLightDownSVG />
					</MinimalButton>
				</>
			) : (
				<>
					<Box
						onClick={checkforPrevJumpPosition}
						style={{
							display: "flex",
							cursor: "pointer",
							padding: "0px 10px",
							opacity: !isHighlightDisable ? "1" : "0.3",
						}}
					>
						<HighLightUpSVG />
					</Box>
					<Box
						onClick={checkforNextJumpPosition}
						style={{
							padding: "0px 5px",
							display: "flex",
							cursor: "pointer",
							opacity: !isHighlightDisable ? "1" : "0.3",
						}}
					>
						<HighLightDownSVG />
					</Box>
				</>
			)}
			<Menu
				id="fade-menu"
				disableRipple
				MenuListProps={{
					"aria-labelledby": "fade-button",
				}}
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left",
				}}
				disableElevation
				getContentAnchorEl={null}
			>
				<MenuItem disableRipple className={classes.menuItem}>
					<TagsInput
						value={highlightFilter?.searchWord || []}
						classNames={classes.highlightTitle}
						onChange={handleChange}
						name="tagInput"
						placeHolder={t("viewer.type_press_enter")}
					/>
				</MenuItem>
				<MenuItem disableRipple className={classes.menuItem}>
					<Box>
						<FormGroup row>
							<FormControlLabel
								value="Date"
								control={
									<StyledCheckbox
										name="dates"
										checked={highlightFilter?.dates}
										retainedFilterJobData={retainedFilterJobData}
									/>
								}
								label={
									<Box style={{ display: "flex", alignItems: "center", width: "44px" }}>
										<Box
											style={{
												width: "0px",
												flex: 1,
												height: "12px",
												borderRadius: "50%",
												marginRight: "5px",
												//background: theme.palette.grey.D700,
											}}
										></Box>
										<Box style={{ ...theme.typography.body1, flex: 1 }}>{t("viewer.dates")}</Box>
									</Box>
								}
								labelPlacement="end"
							/>
							<FormControlLabel
								value="Email"
								control={
									<StyledCheckbox
										name="emails"
										StyledCheckbox
										checked={highlightFilter?.emails}
										retainedFilterJobData={retainedFilterJobData}
									/>
								}
								label={
									<Box style={{ display: "flex", alignItems: "center", width: "50px" }}>
										<Box
											style={{
												width: "0px",
												flex: 1,
												height: "12px",
												borderRadius: "50%",
												marginRight: "5px",
												//background: theme.palette.grey.D800,
											}}
										></Box>
										<Box style={{ ...theme.typography.body1, flex: 1 }}>{t("viewer.emails")}</Box>
									</Box>
								}
								labelPlacement="end"
							/>
							{(!_.isEmpty(retainedFilterJobData?.text) ||
								!_.isEmpty(retainedFilterJobData?.categories) ||
								!_.isEmpty(highlightFilter?.loadedConcept)) && (
								<FormControlLabel
									value="Concepts"
									control={
										<StyledCheckbox
											name="concepts"
											StyledCheckbox
											checked={highlightFilter?.concepts}
											retainedFilterJobData={retainedFilterJobData}
										/>
									}
									label={
										<Box style={{ display: "flex", alignItems: "center", width: "75px" }}>
											<Box
												style={{
													width: "0px",
													flex: 1,
													height: "12px",
													borderRadius: "50%",
													marginRight: "5px",
													//background: theme.palette.grey.D900,
												}}
											></Box>
											<Box style={{ ...theme.typography.body1, flex: 1 }}>{t("viewer.concepts")}</Box>
										</Box>
									}
									labelPlacement="end"
								/>
							)}
							<FormControlLabel
								value="Specific word"
								control={
									<StyledCheckbox
										name="specificWord"
										checked={highlightFilter?.specificWord}
										retainedFilterJobData={retainedFilterJobData}
									/>
								}
								label={
									<Box style={{ display: "flex", alignItems: "center", width: "90px" }}>
										<Box
											style={{
												width: "0px",
												flex: 1,
												height: "12px",
												borderRadius: "50%",
												marginRight: "5px",
												//background: theme.palette.grey.D1000,
											}}
										></Box>
										<Box style={{ ...theme.typography.body1, flex: 1 }}>{t("viewer.specific_word")}</Box>
									</Box>
								}
								labelPlacement="end"
							/>
						</FormGroup>
					</Box>
				</MenuItem>
			</Menu>
		</Box>
	)
}

export default ViewerHighlight
